interface ProgramNaming {
  org_name: string;
  program_name?: string | null;
}

/**
 * The program's own line under the utility's name: the trimmed program name,
 * or null when it is blank or only repeats the utility's name.
 */
export function programLine({ org_name, program_name }: ProgramNaming): string | null {
  const program = program_name?.trim();
  if (!program) return null;
  return program.toLowerCase() === org_name.trim().toLowerCase() ? null : program;
}
